import { BetStatusWatcher, BetStatusWatcherStates } from '../../../logger/BetStatusWatcher';
import { Logger } from '../../../logger/Logger';
import type { CoreStoreType } from '../../../store/CoreStore';
import { autoplayActions } from '../../../store/slices/autoplay/slice';
import { betActions } from '../../../store/slices/bets/slice';
import type { AcceptedBet } from '../../../store/slices/bets/types';
import { GameStatus } from '../../../store/slices/game';
import { gameStateActions } from '../../../store/slices/game/slice';

type AcceptanceState = 'unknown' | 'accepted' | 'not_accepted' | 'rejected';

export class BaseGameCommunicationBetProcessor {
  checkThatAllBetsAreProcessed(acceptedBets: AcceptedBet[]): AcceptanceState {
    let checkResult: AcceptanceState = 'accepted';
    let rejectedBetsCount = 0;
    for (let i = 0; i < acceptedBets.length; i++) {
      if (acceptedBets[i].errorCode === -1) {
        return 'unknown';
      } else if (acceptedBets[i].errorCode > 0) {
        checkResult = 'not_accepted';
        rejectedBetsCount++;
      }
    }

    if (rejectedBetsCount === acceptedBets.length) {
      checkResult = 'rejected';
    }

    return checkResult;
  }

  updateGameStatus(store: CoreStoreType): void {
    const checkResult = this.checkThatAllBetsAreProcessed(store.getState().bets.acceptedBets);
    const isAutoplay = store.getState().autoplay.isInProgress;
    if (checkResult === 'accepted') {
      store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.BetsAccepted));
      BetStatusWatcher.setState(BetStatusWatcherStates.AllAccepted);
      Logger.logEvent('click', 'betsAccepted', Date.now(), 1, 'all' + (isAutoplay ? '_autoplay' : ''), false);
    } else if (checkResult === 'not_accepted') {
      BetStatusWatcher.setState(BetStatusWatcherStates.SomeAccepted);
      store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.NotAllBetsAccepted));
      Logger.logEvent('click', 'betsAccepted', Date.now(), 1, 'some' + (isAutoplay ? '_autoplay' : ''), false);
    } else if (checkResult === 'rejected') {
      store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.BetsRejected));
      store.dispatch(autoplayActions.stop());
      store.dispatch(betActions.resetBetStack());
      BetStatusWatcher.setState(BetStatusWatcherStates.NoneAccepted);
      Logger.logEvent('click', 'betsAccepted', Date.now(), 1, 'none' + (isAutoplay ? '_autoplay' : ''), false);
    }
  }
}
